
const _ajax = (method, path, data, callback) => {
  let r = new XMLHttpRequest()
  r.open(method, path, true)
  r.onreadystatechange = () => {
      if (r.readyState === 4) {
          callback(r.responseText)
      }
  }
  r.send(data)
}


const debounce = (fn, delay = 300) => {
    let timeout = null;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            console.log('in setTimeout')
            fn.apply(this, arguments);
        }, delay);
    };

}



const bindMouse = function() {
    let cartIcon  = document.querySelector('.mini-shopping-cart')
    let miniCart = document.querySelector('#miniCartContainer')
	_ajax('GET', '/?section_id=mini_cart', '', function(r){
		    
            miniCart.innerHTML = r
        
    })
    
    let timer
    cartIcon.addEventListener("mouseenter", function(e) {
        e.preventDefault();
        if (e.target === cartIcon) {
          timer = setTimeout(function () {
            miniCart.classList.add('show')
          }, 600)
        }      
    });

    cartIcon.addEventListener('mouseleave', function(e) {
        e.preventDefault();
        clearTimeout(timer)
        setTimeout(function() {
          if(e.target === cartIcon) {
            miniCart.classList.remove('show')
          }
        }, 600)
    })
}

const __main = function() {
    bindMouse()
}


__main()